// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"f902515d","483":"5e895274","663":"e7bae991","922":"b3ed852a","923":"ce174676"}[chunkId] + ".chunk.js";
};